import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://qbhmzvegsvbjkztoizym.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFiaG16dmVnc3Ziamt6dG9penltIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYzNzM3NjUsImV4cCI6MjA5MTk0OTc2NX0.rGBBRJ9IOH7yBsE5b-LbhSXRN_-1cxu2fiCiQ6P2Ki0'
)

